import React, { useEffect,useState,useContext,useRef } from "react";

import { withStyles, makeStyles } from '@material-ui/core/styles';
import { Select, InputLabel, MenuItem, TextField, FormControl, Button  } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DeleteIcon from '@material-ui/icons/Delete';

import { AppContext } from '../../../App'

const useStyles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,      
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    button: {
        margin: theme.spacing(1),      
      },
    buttonRed: {
      margin: theme.spacing(1),
      backgroundColor: '#f44336',
      "&:hover, &:focus": {
        backgroundColor: '#f54336',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#f74336',
      }
    },
    buttonGreen: {
      margin: theme.spacing(1),
      backgroundColor: '#4CAF50',
      "&:hover, &:focus": {
        backgroundColor: '#4CBF50',
        transition: '0.7s',
      },
      "&:active": {
        backgroundColor: '#4CCF50',
      }
    },    
    comboOptions: {
      fontSize: '17px',
      //color: 'red'
    }
    
  }));

  

function  FiltradoRepresentaciones(){

    const {state, dispatch} = useContext(AppContext)
    
    const classes = useStyles();

    const [valueIdent, setValueIdent] = React.useState("");    
    const [enCalidadDeCombo, setEnCalidadDeCombo] = useState("");
    const [estadoCombo, setEstadoCombo] = useState(-1);
    

    const arrayUniqueByIdentPendientes = [...new Map(state.arraySolicitudesRepresentacionPendientes.map(item =>
        [textoIdentificacionPendientes(item), textoIdentificacionPendientes(item)])).values()];
    
    const arrayUniqueByIdentRespondidas = [...new Map(state.arraySolicitudesRepresentacionRespondidas.map(item =>
        [textoIdentificacionRespondidas(item), textoIdentificacionRespondidas(item)])).values()];

    const arrayUniqueByIdentBajas = [...new Map(state.arraySolicitudesRepresentacionBajas.map(item =>
      [textoIdentificacionRespondidas(item), textoIdentificacionRespondidas(item)])).values()];

    const arrayMix = [].slice.call(arrayUniqueByIdentPendientes).concat([].slice.call(arrayUniqueByIdentRespondidas)).concat([].slice.call(arrayUniqueByIdentBajas));
    
    const arrayUniqueByIdent = [...new Set(arrayMix).add('')];

    const autoC = useRef(null);

    function textoIdentificacionPendientes(solicitud)
    {
      var enCalidadDe = textoUsuarioEnCalidadDe(solicitud);
      if (enCalidadDe == "Mi Representado")
            return (solicitud.nifRepresentadoSolicitud + (SolicitudDeRepresentado(solicitud.tipoSolicitudRepresentacion)? ' ' + solicitud.razonSocialRepresentadoSolicitud : '')).trim();
      else if (enCalidadDe == "Mi Representante")
          return (solicitud.nifRepresentanteSolicitud).trim(); 
      else
          return '---';
    }

    function textoIdentificacionRespondidas(solicitud)
    {
      var enCalidadDe = textoUsuarioEnCalidadDe(solicitud);
      if (enCalidadDe == "Mi Representado")
            return (solicitud.nifRepresentadoSolicitud + ' ' + solicitud.razonSocialRepresentadoSolicitud).trim();
      else if (enCalidadDe == "Mi Representante")
          return (solicitud.nifRepresentanteSolicitud + ' ' + solicitud.razonSocialRepresentanteSolicitud).trim();
      else
          return '---';
    }
    
    function textoUsuarioEnCalidadDe(solicitud)
    {     
      if (SolicitudDeRepresentante(solicitud.tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(solicitud.rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
        else if (EnCalidadDeReceptorSolicitud(solicitud.rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
      }          
      else if (SolicitudDeRepresentado(solicitud.tipoSolicitudRepresentacion)) {
        if (EnCalidadDeEmisorSolicitud(solicitud.rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representante';
        }
        else if (EnCalidadDeReceptorSolicitud(solicitud.rolDelUsuarioEnLaSolicitud)){
          return 'Mi Representado';
        }
      } 
      else
          return '---';      
    }

    function EnCalidadDeEmisorSolicitud(rolDelUsuarioEnLaSolicitud){
        if ( rolDelUsuarioEnLaSolicitud == 1 ) 
            return true;      
        
        return false;
    }

    function EnCalidadDeReceptorSolicitud(rolDelUsuarioEnLaSolicitud){
        if ( rolDelUsuarioEnLaSolicitud == 2 ) 
            return true;      
        
        return false;
    }
        

    function SolicitudDeRepresentante(tipoSolicitudRepresentacion){
        if (tipoSolicitudRepresentacion == 1) 
            return true;
        return false;
    }

    function SolicitudDeRepresentado(tipoSolicitudRepresentacion){
        if (tipoSolicitudRepresentacion == 2) 
            return true;
        return false;
    }
   
    function actualizaPendientesUI(solicitudesFiltradas){        
        dispatch({ type: 'UPDATE_SOLICITUDES_PENDIENTES_UI_STATUS', data: solicitudesFiltradas,});
    }

    function actualizaRespondidasUI(solicitudesFiltradas){
        dispatch({ type: 'UPDATE_SOLICITUDES_RESPONDIDAS_UI_STATUS', data: solicitudesFiltradas,});
    }

    function actualizaBajasUI(solicitudesFiltradas){
      dispatch({ type: 'UPDATE_SOLICITUDES_BAJAS_UI_STATUS', data: solicitudesFiltradas,});
    }

    const handleFiltraPorIdentificacion = (value) => {      
        setValueIdent(value);

        handleFiltraTotal(value, enCalidadDeCombo, estadoCombo);
    };

    const handleFiltraPorEnCalidadDe = (event) => {
        setEnCalidadDeCombo(event.target.value);

        handleFiltraTotal(valueIdent, event.target.value, estadoCombo);
    };
    
    const handleFiltraPorEstado = (event) => {
        setEstadoCombo(event.target.value);

        handleFiltraTotal(valueIdent, enCalidadDeCombo, event.target.value);
    };

    function handleFiltraTotal(filtroId, filtroEnCalidad, filtroEstado){
        
        var arrayPendTemp = state.arraySolicitudesRepresentacionPendientes;
        var arrayRespTemp = state.arraySolicitudesRepresentacionRespondidas;
        var arrayBajTemp = state.arraySolicitudesRepresentacionBajas;

        if (filtroId != null && filtroId != ""){                    
            arrayPendTemp = arrayPendTemp.filter((item) => String(textoIdentificacionPendientes(item).toUpperCase()).includes(filtroId.toUpperCase()));
            arrayRespTemp = arrayRespTemp.filter((item) => String(textoIdentificacionRespondidas(item).toUpperCase()).includes(filtroId.toUpperCase()));
            arrayBajTemp = arrayBajTemp.filter((item) => String(textoIdentificacionRespondidas(item).toUpperCase()).includes(filtroId.toUpperCase()));
        }

        if (filtroEnCalidad != null && filtroEnCalidad != ""){                              
            arrayPendTemp = arrayPendTemp.filter((item) => textoUsuarioEnCalidadDe(item) == filtroEnCalidad);
            arrayRespTemp = arrayRespTemp.filter((item) => textoUsuarioEnCalidadDe(item) == filtroEnCalidad);
            arrayBajTemp = arrayBajTemp.filter((item) => textoUsuarioEnCalidadDe(item) == filtroEnCalidad);
        }

        if (filtroEstado != null && filtroEstado != -1){                              
          if (filtroEstado != 999){   
            //Próxima caducidad / expiración       
            arrayPendTemp = arrayPendTemp.filter((item) => item.estadoActual == filtroEstado);
            arrayRespTemp = arrayRespTemp.filter((item) => item.estadoActual == filtroEstado);            
            arrayBajTemp = arrayBajTemp.filter((item) => item.estadoActual == filtroEstado);            
          }
          else{            
            arrayPendTemp = arrayPendTemp.filter((item) => caducaOExpira(item.estadoActual, item.fechaSolicitud, item.vigencia));
            arrayRespTemp = arrayRespTemp.filter((item) => caducaOExpira(item.estadoActual, item.fechaSolicitud, item.vigencia));
            arrayBajTemp = arrayBajTemp.filter((item) => caducaOExpira(item.estadoActual, item.fechaSolicitud, item.vigencia));
          }
        }

        actualizaPendientesUI(arrayPendTemp);
        actualizaRespondidasUI(arrayRespTemp);
        actualizaBajasUI(arrayBajTemp);

        dispatch({ type: 'UPDATE_RESET_PAGE', data: true,});            
    }

    function caducaOExpira(estadoActual, fechaSolicitud, fechaVigencia){      
      var fechaActualSinGMT = new Date(new Date().toUTCString().split(' ').slice(0, 4).join (' '));      
      var fechaActualAUnMesSinGMT = new Date(fechaActualSinGMT.setMonth(fechaActualSinGMT.getMonth()+1));   
      fechaActualAUnMesSinGMT = new Date(fechaActualAUnMesSinGMT.getFullYear(), fechaActualAUnMesSinGMT.getMonth(), fechaActualAUnMesSinGMT.getDate(), 23, 59, 59);

      var fechaSolicitudSinGMT = new Date(new Date(fechaSolicitud).toUTCString().split(' ').slice(0, 4).join (' '));      
      var fechaVigenciaSinGMT = new Date(new Date(fechaVigencia).toUTCString().split(' ').slice(0, 4).join (' '));
      var fechaCaducidadSinGMT = new Date(fechaSolicitudSinGMT.setMonth(fechaSolicitudSinGMT.getMonth()+1));       
               
      if (estadoActual == "1" && (fechaActualAUnMesSinGMT >= fechaCaducidadSinGMT || fechaActualAUnMesSinGMT >= fechaVigenciaSinGMT)){
        //Solicitada
        return true;
      }
      else if (estadoActual == "2" && fechaActualAUnMesSinGMT >= fechaVigenciaSinGMT){
        //Aceptada
        return true;
      }

      return false;
      
    }

    const handleResetFiltros = (event) => {
        setValueIdent("");

        if (autoC && autoC.current && autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')){
            const ele = autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
            if (ele) ele.click();
        }


        setEnCalidadDeCombo("");
        setEstadoCombo(-1);
        dispatch({ type: 'UPDATE_RESET_FILTRADO', data: false,});
        handleFiltraTotal("", "", -1);
    };

    useEffect(() => {           
        if (state.resetFiltrado){
            setValueIdent("");

            if (autoC && autoC.current && autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')){
                const ele = autoC.current.getElementsByClassName('MuiAutocomplete-clearIndicator')[0];
                if (ele) ele.click();
            }

            setEnCalidadDeCombo("");
            setEstadoCombo(-1);
            dispatch({ type: 'UPDATE_RESET_FILTRADO', data: false,});
            handleFiltraTotal("", "", -1);
        }
    }); 
    

    return (
        <>            
            { !state.resetFiltrado &&
               ((state.arraySolicitudesRepresentacionPendientes && state.arraySolicitudesRepresentacionPendientes.length > 0) ||
               (state.arraySolicitudesRepresentacionRespondidas && state.arraySolicitudesRepresentacionRespondidas.length > 0) ||
               (state.arraySolicitudesRepresentacionBajas && state.arraySolicitudesRepresentacionBajas.length > 0)) &&
                <div>   
                    <div><strong>FILTROS DE BÚSQUEDA:</strong></div>
                    <br/>                                                                  
                    Identificación: 
                    <FormControl variant="outlined" className={classes.formControl}>                        
                        <Autocomplete
                            id="combo-box-demo"                            
                            options={arrayUniqueByIdent.sort()}
                            freeSolo
                            clearOnBlur={false}
                            style={{ width: 300, fontSize: 17 }}
                            //value={valueIdentAC}
                            ref={autoC}
                            onChange={(event, newValue) => { handleFiltraPorIdentificacion(newValue) }}                            
                            onInputChange={(event, newValue) => { handleFiltraPorIdentificacion(newValue) }}  
                            renderInput={(params) => {
                              params.inputProps.className = classes.comboOptions
                              return <TextField {...params} label="Identificación" variant="outlined" 
                                          
                              />
                              }
                            }
                        />
                    </FormControl>

                    En calidad de:
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel >En calidad de</InputLabel>
                        <Select
                            native
                            value={enCalidadDeCombo}
                            onChange={handleFiltraPorEnCalidadDe}
                            label="En calidad de"
                            style={{ fontSize: 17 }}                            
                        >
                            <option aria-label="None" value="" />
                            <option value={"Mi Representante"}>Mi Representante</option>
                            <option value={"Mi Representado"}>Mi Representado</option>
                        </Select>
                    </FormControl>

                    Estado:
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel >Estado</InputLabel>
                        <Select
                            native
                            value={estadoCombo}
                            onChange={handleFiltraPorEstado}
                            label="Estado"
                            style={{ fontSize: 17 }} 
                        >
                            <option aria-label="None" value={-1} />                            
                            <option value={1}>Solicitada</option>
                            <option value={2}>Aceptada</option>
                            <option value={3}>Rechazada</option>
                            <option value={4}>Expirada</option>
                            <option value={5}>Cancelada</option>
                            <option value={6}>Revocada</option>
                            <option value={7}>Caducada</option>
                            <option value={8}>Baja NIF en base de datos</option>
                            <option value={9}>Baja inicio concurso</option>
                            <option value={10}>Baja fin concurso</option>
                            <option value={999}>Próxima expiración/caducidad</option>
                        </Select>
                    </FormControl>

                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        startIcon={<DeleteIcon />}
                        onClick={handleResetFiltros}
                    >
                        Limpia
                    </Button>
                </div>
            }
        </>            
    )
}
export default FiltradoRepresentaciones
